import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Approvals from '@/pages/Approvals.vue'
import ApprovalsView from '@/pages/Approvals/View.vue'
import ApprovalsDetail from '@/pages/Approvals/Detail.vue'
// import ApprovalsEdit from '@/pages/Approvals/Edit.vue'
// import ApprovalsNew from '@/pages/Approvals/New.vue'

import Passes from '@/pages/Passes.vue'
import PassesView from '@/pages/Passes/View.vue'
import PassesDetail from '@/pages/Passes/Detail.vue'
import PassesScan from '@/pages/Passes/Scan.vue'

import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'

import Clients from '@/pages/Clients.vue'
import ClientsView from '@/pages/Clients/View.vue'
import ClientsDetail from '@/pages/Clients/Detail.vue'

import CheckIns from '@/pages/CheckIns.vue'
import CheckInsView from '@/pages/CheckIns/View.vue'

import CheckOut from '@/pages/CheckOut.vue'
import CheckOutView from '@/pages/CheckOut/View.vue'

import Stats from '@/pages/Stats.vue'
import StatsView from '@/pages/Stats/View.vue'

import PassDetail from '@/pages/PassDetail.vue'
import PassDetailView from '@/pages/PassDetail/View.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'



const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						name: "Settings",
						component: SettingsView
					}
				]
			},
			{
				path: 'approvals',
				component: Approvals,
				children: [
					{
						path: '',
						name: "Entry Pass Management",
						component: ApprovalsView
					},
					{
						path: 'detail/:hash_id',
						name: 'Entry Pass Management',
						component: ApprovalsDetail
					}
				]
			},
			{
				path: 'passes',
				component: Passes,
				children: [
					{
						path: '',
						name: "Entry Pass Management",
						component: PassesView
					},
					{
						path: 'detail/:hash_id',
						name: 'Entry Pass Management',
						component: PassesDetail
					},
					{
						path: 'scan',
						name: 'Entry Pass Management',
						component: PassesScan
					}
				]
			},
			{
				path: 'clients',
				component: Clients,
				children: [
					{
						path: '',
						name: "Clients Management",
						component: ClientsView
					},
					{
						path: 'detail/:hash_id',
						name: "Clients Management",
						component: ClientsDetail
					}
				]
			},
			{
				path: 'pass_detail',
				component: PassDetail,
				children: [
					{
						path: ':hash_id',
						name: "Pass Detail",
						component: PassDetailView
					}
				]
			},
			{
				path: '/check_outs',
				component: CheckOut,
				children: [
					{
						path: '',
						name: "Check-Out Management",
						component: CheckOutView
					}
				]
			},
			{
				path: 'stats',
				component: Stats,
				children: [
					{
						path: '',
						name: "ទិន្នន័យស្ថិតិ",
						component: StatsView
					}
				]
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						name: "Administrators",
						component: AdministratorsView
					},
					{
						path: 'edit/:id',
						name: 'Administrators',
						component: AdministratorsEdit
					}
				]
			}
		]
	},
	{
		path: '/check_ins',
		component: CheckIns,
		children: [
			{
				path: '',
				name: "Check-Ins Management",
				component: CheckInsView
			}
		]
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js